// Route path constants
export const ROUTES = {
  ROOT: "/",
  LOGIN: "/login",
  HOME: "/home",
  AUTH_CALLBACK: "/auth-callback/*",
  AUTH_REDIRECT: "/auth-redirect",
  ERROR: "/error",
  NOT_FOUND: "*"
}
